var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNavIcon3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0,0,256,256",
    width: "48px",
    height: "48px",
    fillRule: "nonzero",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(5.33333,5.33333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.25,26c-1.402,0 -2.774,0.123 -4.113,0.348c1.834,4.728 3.224,9.672 4.127,14.785c4.767,-2.867 8.252,-7.648 9.356,-13.286c-2.892,-1.187 -6.055,-1.847 -9.37,-1.847zM26.023,24.245c-0.535,-1.214 -1.103,-2.411 -1.699,-3.591c-4.159,1.517 -8.646,2.346 -13.324,2.346c-2.362,0 -4.671,-0.223 -6.918,-0.627c-0.043,0.538 -0.082,1.078 -0.082,1.627c0,5.405 2.164,10.308 5.661,13.911c3.396,-6.478 9.271,-11.46 16.362,-13.666zM27.105,19.505c0.659,1.315 1.289,2.647 1.876,4.003c1.707,-0.33 3.467,-0.508 5.269,-0.508c3.416,0 6.687,0.624 9.712,1.758c0.009,-0.254 0.038,-0.502 0.038,-0.758c0,-4.98 -1.842,-9.531 -4.864,-13.035c-3.412,3.559 -7.488,6.471 -12.031,8.54zM11.985,39.95c3.35,2.53 7.503,4.05 12.015,4.05c2.641,0 5.159,-0.527 7.469,-1.461c-0.885,-5.378 -2.338,-10.564 -4.286,-15.505c-6.682,1.994 -12.189,6.738 -15.198,12.916zM37.015,8.845c-3.502,-3.011 -8.045,-4.845 -13.015,-4.845c-2.181,0 -4.276,0.363 -6.243,1.011c2.99,3.687 5.662,7.641 7.963,11.829c4.271,-1.922 8.1,-4.651 11.295,-7.995zM4.552,19.41c2.094,0.381 4.246,0.59 6.448,0.59c4.173,0 8.179,-0.722 11.909,-2.033c-2.316,-4.167 -5.001,-8.101 -8.026,-11.746c-5.134,2.643 -8.972,7.437 -10.331,13.189z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavIcon3);
export default __webpack_public_path__ + "static/media/nav-icon3.19e0ed540ebdde5095362fcc8770d7f7.svg";
export { ForwardRef as ReactComponent };